var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAplus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    encoding: "utf-8",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 207",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B3133",
    d: "M510 24A91 91 0 0 1 529 26A50 50 0 0 1 565 63A73 73 0 0 1 565 92A51 51 0 0 1 528 127A69 69 0 0 1 510 129 L486 129 486 180 447 180 447 24 486 24 486 24 510 24zM501 97A38 38 0 0 0 511 96A20 20 0 0 0 525 84A42 42 0 0 0 525 70A19 19 0 0 0 512 56A59 59 0 0 0 501 55 L486 55 486 97 501 97zM425 180 L361 24 323 24 261 180 289 180 A20 20 0 0 0 308 166 L315 147 370 147 378 167 A20 20 0 0 0 397 180 L425 180zM342 63 L361 116 324 116 342 63zM886 144 L877 159 A98 98 0 0 0 912 179A74 74 0 0 0 958 176A47 47 0 0 0 984 152A58 58 0 0 0 987 115A46 46 0 0 0 960 89A228 228 0 0 1 928 77A12 12 0 0 1 920 67A13 13 0 0 1 928 56A25 25 0 0 1 945 54A59 59 0 0 1 960 62A13 13 0 0 0 976 58 L987 40 A86 86 0 0 0 950 23A68 68 0 0 0 902 32A47 47 0 0 0 883 65A48 48 0 0 0 895 101A69 69 0 0 0 927 116A43 43 0 0 1 947 125A14 14 0 0 1 948 143A21 21 0 0 1 931 149A50 50 0 0 1 912 143 L906 139 A15 15 0 0 0 886 144zM758 121A29 29 0 0 0 815 121 L815 24 855 24 855 121 A66 66 0 0 1 827 172A82 82 0 0 1 746 172A66 66 0 0 1 719 121 L719 24 758 24 758 121zM693 146 L635 146 635 24 596 24 596 180 693 180 693 146z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA5758",
    d: "M108 137 L108 196 139 181 108 137zM173 166 L206 149 108 11 108 74 173 166z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F16664",
    d: "M43 166 L11 149 108 11 108 74 43 166zM108 137 L108 196 78 181 108 137z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAplus);
export default __webpack_public_path__ + "static/media/logo_aplus.ac006e713bb0c4d85613612fa6658981.svg";
export { ForwardRef as ReactComponent };